import { gql } from '../../../../../hooks'

export const DELETE_LABORATORIES = gql`
  mutation AdministrationDeleteReportLaboratories($id: ID!) {
    aDelete(path: "other/laboratories", id: $id) {
    }
  }
`

export const LIST_LABORATORIES = gql`
  query AdministrationListReportLaboratories(
    $page: Int
    $limit: Int
    $filter: JSONObject
  ) {
    aList(
      path: "other/laboratories"
      filter: $filter
      page: $page
      limit: $limit
    ) {
      pagination {
        page
        limit
        number_of_pages
      }
    }
  }
`
